(() => {
  const resizeEditorialGrid = (grid) => {
    if (!grid || grid.dataset.galleryLayout !== 'editorial') return;

    const visibleItems = [...grid.querySelectorAll('[data-gallery-item]:not([hidden])')];
    if (window.innerWidth < 768) {
      visibleItems.forEach((item) => { item.style.gridRowEnd = 'auto'; });
      return;
    }

    const styles = window.getComputedStyle(grid);
    const rowHeight = parseFloat(styles.getPropertyValue('grid-auto-rows'));
    const rowGap = parseFloat(styles.getPropertyValue('row-gap'));
    if (!rowHeight) return;

    visibleItems.forEach((item) => {
      const card = item.querySelector('.portfolio-gallery__card');
      if (!card) return;
      const height = card.getBoundingClientRect().height;
      const rowEnd = `span ${Math.ceil((height + rowGap) / (rowHeight + rowGap))}`;
      if (item.style.gridRowEnd !== rowEnd) item.style.gridRowEnd = rowEnd;
    });
  };

  const initialiseGallery = (grid) => {
    if (!grid || grid.dataset.galleryInitialised === 'true') return;
    grid.dataset.galleryInitialised = 'true';

    const section = grid.closest('[id^="section-id-"]');
    const button = section && section.querySelector('[data-gallery-load-button]');
    const items = [...grid.querySelectorAll('[data-gallery-item]')];

    const resize = () => window.requestAnimationFrame(() => resizeEditorialGrid(grid));

    grid.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', resize, { once: true });
    });

    if (button) {
      button.addEventListener('click', () => {
        const count = Number.parseInt(button.dataset.loadCount, 10) || 3;
        const hiddenItems = items.filter((item) => item.hidden);
        hiddenItems.slice(0, count).forEach((item) => { item.hidden = false; });
        if (hiddenItems.length <= count) button.hidden = true;
        resize();
      });
    }

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(resize);
      observer.observe(grid);
    } else {
      window.addEventListener('resize', resize);
    }

    resize();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-gallery-load-more]').forEach(initialiseGallery);
  };

  initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('[data-gallery-item]');
    if (!item) return;
    item.hidden = false;
    resizeEditorialGrid(item.closest('[data-gallery-load-more]'));
  });
})();
